import Monaco, { OnChange } from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/components/Monaco'
import proxyAction from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/globalActions/proxy.json'
import useDatasource from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/hooks/useDatasource'
import useSearchParams from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/hooks/useSearchParams'

export function Perform() {
  const [datasource, setDatasource] = useDatasource(true)

  const datasourceActions: typeof datasource.actions = { _proxy: proxyAction, ...datasource.actions }

  const [searchParams] = useSearchParams()

  const activeActionKey = searchParams.get('action')!

  const handlePerformChange: OnChange = (value = '') => {
    if (!activeActionKey) return

    setDatasource(datasource => ({
      ...datasource,
      actions: {
        ...datasource.actions,
        [activeActionKey]: {
          ...(activeActionKey === '_proxy' ? proxyAction : {}),
          ...datasource.actions[activeActionKey],
          perform: value.trim()
        }
      }
    }))
  }

  return (
    <div className="flex flex-1 flex-col">
      <div className="bg-gray-100 px-4 py-2 text-xs">Perform</div>
      <Monaco
        key={activeActionKey}
        showBeautifyButton={true}
        language="typescript"
        defaultValue={datasourceActions[activeActionKey].perform}
        onChange={handlePerformChange}
      />
    </div>
  )
}
